export const MOBILE_MENU_ICON_WRAPPER_SIZE = 24;
export const MOBILE_MENU_ICON_WIDTH = 16;
export const MOBILE_MENU_LARGE_ICON_WIDTH = 24;
export const MOBILE_MENU_ICON_HEIGHT = 16;

export const DESKTOP_MENU_ICON_WIDTH = 24;
export const DESKTOP_MENU_ICON_HEIGHT = 24;

export const MAIN_NAVIGATION_MIN_HEIGHT = 56;
